// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-statistics-agency {\n    position: relative;\n    padding-top: 100px;\n}\n", "",{"version":3,"sources":["webpack://src/components/AgencyAction/AgencyDashboard/Statistics/Statistics.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kBAAkB;AACtB","sourcesContent":[".section-statistics-agency {\n    position: relative;\n    padding-top: 100px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
